import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { openCommissionEditModal } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getModuleDataByModuleType } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import {
  getProfileGruser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { AppState } from '../../../../../types/store';
import { ShopItemType } from '../../../../../types/shop';
import { Props } from './ShopCommissions';

export type DispatchProps = Pick<Props, 'onCreate'>;
type StateProps = Pick<Props, 'isOpenForCommissions' | 'isOwner' | 'total'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const gruser = getProfileGruser(state);
  const moduleData = getModuleDataByModuleType(
    state as any,
    gruser,
    'commissions'
  );
  const { isOpenForCommissions } = moduleData;
  const streamId = getShopItemsStreamId(ShopItemType.COMMISSIONS);
  return {
    isOpenForCommissions,
    isOwner: isCurrentUserProfileOwner(state),
    total: streamSelectors.getTotal(state, streamId),
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => {
  return {
    onCreate: () =>
      dispatch(openCommissionEditModal({ deviationId: undefined })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
